import { ICreateContactData } from './CreateClientContact';
import { ILenderContactData } from './ILenderContact';

// The BackEnd requires that a POST request for a LenderOrderContact have a specific structure.
// These interfaces and functions produce that structure.

export interface ICreateLenderOrderContactRequest {
  lenderUserId?: string;
  contactData?: ICreateContactData;
  functions: string[];
  notes?: string;
}

export const convertFromILenderContactDataToICreateLenderOrderContactRequest = (
  data: ILenderContactData
): ICreateLenderOrderContactRequest => {
  let request: ICreateLenderOrderContactRequest = {
    lenderUserId: data.id,
    functions: data.functions,
    notes: data.notes,
  };
  if (!request.lenderUserId) {
    request.contactData = {
      firstName: data.firstName,
      middleName: data.middleName,
      lastName: data.lastName,
      emailAddress: data.email,
      phoneNumber: data.phoneNumber,
    };
  }
  return request;
};
